export default __webpack_public_path__ + "static/MeenakshiDattaGhosh-146613c278952763b050f5c3038601b8.png";